import Landing from '../views/Landing.vue';
import Home from '../views/Home.vue';

export default [
  {
    path: '/',
    name: 'Landing',
    component: Landing, // () => import('../views/Landing.vue'),
  },
  {
    path: '/:floorId',
    name: 'Floor',
    component: Home,
  },
  {
    path: '/:floorId/:roomId',
    name: 'Room',
    component: Home,
  },
  {
    path: '/:floorId/:roomId/:exhibitId',
    name: 'Exhibit',
    component: Home,
  },
  /* {
    path: '/:floorId/:roomId/:exhibitId/:itemId',
    name: 'ExhibitItem',
    component: Home,
  }, */
];
